import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  adminList: [],
  adminListDetails: {},
};

export const adminListSLice = createSlice({
  name: "adminListSLice",
  initialState,
  reducers: {
    updateAdminList(state, action) {
      state.adminList = action.payload.membersList;
    },
    updateAdminListDetails(state, action) {
      state.adminListDetails = action.payload.adminListDetails;
    },
    resetAdminState: (state) => initialState,
  },
});
export const adminActions = adminListSLice.actions;
export default adminListSLice.reducer;
